module.exports = __webpack_public_path__ + "img/20210902_151613.c21cc477.jpg";